<template>
  <div>
    <h2>Download Results</h2>
    <button @click="download">Download as PDF</button>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  methods: {
    download() {
      axios.get('/api/download', { responseType: 'blob' })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'result.pdf');
          document.body.appendChild(link);
          link.click();
        });
    }
  }
}
</script>
